import parse from "date-fns/parse";
import parseISO from "date-fns/parseISO";
import format from "date-fns/format";
import formatISO from "date-fns/formatISO";
import { addYears, intervalToDuration, isAfter, isBefore } from "date-fns";

const localDateFormat = "dd.MM.yyyy";

export const isMobileView = () => document.documentElement.clientWidth >= 768;
export const isDesktopView = () => document.documentElement.clientWidth >= 992;

export const convertSecondsToTime = (seconds) => {
  const time = intervalToDuration({ start: 0, end: seconds * 1000 });
  return (
    "time",
    `${time.minutes.toString().padStart(2, "0")}:${time.seconds
      .toString()
      .padStart(2, "0")}`
  );
};

export const parseServerDate = (serverString) => parseISO(serverString);

export const parseLocalDate = (localString) =>
  parse(localString, localDateFormat, new Date());

export const formatToLocalDate = (dateString) => {
  if (!dateString) return dateString;
  return format(parseServerDate(dateString), localDateFormat);
};

export const localDateToServerDate = (dateString) => {
  if (!dateString) return dateString;
  return formatISO(parseLocalDate(dateString), { representation: "date" });
};

export const localDateToServerDateIfCan = (dateString) => {
  try {
    return localDateToServerDate(dateString);
  } catch (e) {
    return "";
  }
};

export const formatChars = {
  9: "[0-9]",
  7: "[7]",
  a: "[A-Za-z]",
  "*": "[+]",
};

export const emptyFieldErrorMessage = "Необходимо указать значение";

export const phoneErrorMessageTemplate = {
  wrongLength: "Неверное количество знаков",
  wrongNumber: "Проверьте правильность введенного номера",
};

// можно: русские буквы, пробелы в середине; нельзя: пробел вначале и конце
export const regex =
  /^(?=.*[а-яА-ЯёЁ].*[а-яА-ЯёЁ])[-а-яА-ЯёЁ—]+(\s+[-а-яА-ЯёЁ—]+)*$/;

export const regexOnlyNumbers = /^\d+$/;

// можно: русские буквы, цифры, пробел, дефис, №; нелья пробелы в начале и конце
export const regexUniversal =
  /^[-а-яА-ЯёЁ0-9-()+,.;*№N—/\\]+(\s+[-а-яА-ЯёЁ0-9-()+,.;*№N—/\\]+)*$/;

export const regexCompanyName = /^[––а-яА-ЯёЁ0-9-()№N,.:;"«»*—+\s/\\]+$/;
export const regexStreet = /^[-а-яА-ЯёЁ0-9-–—,.№N\s]+$/;
export const regexHouse = /^[-а-яА-ЯёЁ0-9-–—,.№N\s/\\]+$/;

// можно: русские  буквы, цифры, пробел, дефис, №, ковычки, <>; нелья пробелы в начале и конце
export const regexUniversalRusWithDigitsAndQuotes =
  /^[-а-яА-ЯёЁ0-9\-()—–—+,.:;*№N/\\"'<>«»]+(\s+[-а-яА-ЯёЁ0-9\-()+—–—,.:;*№N/\\"'<>«»]+)*$/;

export const mailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

export const mailRegexStrong =
  /^([a-zA-Z0-9!#$%&*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[a-zA-Z](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)$/;

export const mailRegexBki =
  /^([+0-9a-zA-ZА-Яа-я_-][+0-9a-zA-ZА-Яа-я_.-]*[+0-9a-zA-ZА-Яа-я_-])@([+0-9a-zA-ZА-Яа-я-]+\.)[+0-9a-zA-ZА-Яа-я]+$/;

// Регулярное выражение для проверки промокода
export const promoCodeRegex = /^[a-zA-Zа-яА-Я0-9]+$/;

export const validateEmail = (email) => {
  if (!mailRegexStrong.test(email)) return false;

  return true;
};

// можно: дата в формате dd/mm/yyyy, dd-mm-yyyy или dd.mm.yyyy. (проверяет на неправильные дата в феврале)
export const regexDate =
  /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})/;

// метод для правильного отображения даты при вводе в инпут
const convertToDate = (st) => {
  const pattern = /(\d{4})-(\d{2})-(\d{2})/;
  return st.replace(pattern, "$3.$2.$1");
};

// метод, чтобы данные в дате были правильно расставлены, сейчас в инпуте жестко зашито так: мм.дд.гггг, а валидация написана как для дд.мм.гггг
// поэтому если вводим с клавиатуры дату, чтобы ее правильно понять нужно переставить местами данные, привести датут к виду, который приходит с date-picker
export const convertToValidDate = (date) => {
  const pattern = /(\d{2}).(\d{2}).(\d{4})/;
  return date.replace(pattern, "$3-$2-$1");
};

export const checkIfNumbersSequential = (str) => {
  const arr = str.split("");
  if (arr[0] > arr[arr.length - 1]) arr.reverse();
  for (let index = 0; index < arr.length; index++) {
    if (arr[index + 1] && +arr[index] + 1 !== +arr[index + 1]) {
      return false;
    }
  }
  return true;
};

export const convertNumber = (number) => {
  if (!number) return "";
  const n = number.replaceAll(/[+_\s()-]/g, "");
  return `+${n[0]} (${n[1]}${n[2]}${n[3]}) ${n[4]}${n[5]}${n[6]} ${n[7]}${n[8]} ${n[9]}${n[10]}`;
};

export const PeriodTypeId = {
  days: "40250ae9-0770-4ca9-939d-fdb3a3c867bd",
  weeks: "c0259c89-d87e-404c-84dd-30282d0c7abf",
};

// метод для правильных окончаний в сроке займа
// TODO:: Определиться, что должно выводиться по умолчанию
// eslint-disable-next-line consistent-return
export const periodEndings = (number, type) => {
  const days1 = [
    0, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 25, 26, 27, 28, 29,
    30,
  ];
  const days2 = [21, 31];
  const days3 = [22, 23, 24];

  const weeks1 = [6, 8, 10, 12, 14, 16, 18, 20];
  const weeks2 = [2, 4, 22, 24];

  if (type === PeriodTypeId.days) {
    if (days1.includes(number)) {
      return "дней";
    }
    if (days2.includes(number)) {
      return "день";
    }
    if (days3.includes(number)) {
      return "дня";
    }
  } else {
    if (weeks1.includes(number)) {
      return "недель";
    }
    if (weeks2.includes(number)) {
      return "недели";
    }
  }
};

// удаляем пробелы из строки
export const deleteWhiteSpace = (str) => str.replace(/\s/g, "");

// разбиваем на разряды число
export const addRanks = (str) =>
  str.replace(/\s/g, "").replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, "$1 ");

// удаляем в строке нули которые стоят вначале
export const deleteNulls = (str) => addRanks(str.replace(/^0+/, ""));

// Возвращает функцию, которая, пока она продолжает вызываться,
// не будет запускаться.
// Она будет вызвана один раз через N миллисекунд после последнего вызова.
export const debounce = (timeout = 400) => {
  let timer;
  return (args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      args();
    }, timeout);
  };
};

// форматирование срока кредитования. на выходе строка "21 день"
export const getHumanPeriodType = (selected) => {
  if (!selected) return "";
  return periodEndings(selected.number, selected.periodTypeId);
};

export const getCookie = (name) => {
  // Split cookie string and get all individual name=value pairs in an array
  const cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
      and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return '' if not found
  return "";
};

export const checkRepeatSequence = (str, maxCount = 3) => {
  let currentChar = "";
  let count = 0;

  for (let i = 0; i < str.length; i++) {
    if (currentChar !== str[i]) {
      count = 1;
      currentChar = str[i];
      // eslint-disable-next-line no-continue
      continue;
    }

    count++;
    if (count >= maxCount) {
      return false;
    }
  }

  return true;
};

export const checkSNILS = (value) => {
  const snils = value.replaceAll(/[\D]+/g, ""); // удаляем лишние знаки

  if (snils.length !== 11) {
    return "Значение поля СНИЛС должно состоять из 11 цифр.";
  }

  // В номере СНИЛС не должно быть трех одинаковых цифр, идущих подряд друг за другом
  if (!checkRepeatSequence(snils.slice(0, 9))) {
    return "Введен некорректный СНИЛС";
  }

  // Проверка контрольного числа Страхового номера проводится только для номеров больше номера 001-001-998
  if (parseInt(snils.slice(0, 9), 10) <= 1001998) {
    return true;
  }

  const checkSum = parseInt(snils.slice(-2, 11), 10); // берем посление 2 символа
  let res = [...snils.slice(0, -2)] // считаем сумму без последних двух символов
    .map((number, index) => number * (9 - index))
    .reduce((acc, val) => acc + val, 0);

  while (res > 101) res -= 101;
  if (res > 99) res = 0;
  // Сверяем получившуюся сумму с требуемой
  if (checkSum !== res) {
    return "Введен некорректный СНИЛС";
  }
  return true;
};

export const regexRusSpace = /^[а-яА-ЯёЁ\s]*$/;
export const regexRusSpaceDash = /^[а-яА-ЯёЁ\s-]*$/;
export const regexRusSpaceDashDot = /^[а-яА-ЯёЁ\s-.]*$/;
export const regexRusNumbersSpaceDotСommaDash = /^[а-яА-ЯёЁ0-9.,№\s-]*$/;
export const regexEngRusNumbersSpaceDotСommaDash =
  /^[а-яА-ЯёЁa-zA-Z0-9.,№\s-]*$/;

export const checkDateOrder = ({ earlier, later }) => {
  if (!earlier || !later) return true;
  return isAfter(parseLocalDate(later), parseLocalDate(earlier));
};

export const getDomainWithoutSubdomain = (url) => {
  const urlParts = new URL(url).hostname.split(".");

  return urlParts
    .slice(0)
    .slice(-(urlParts.length === 4 ? 3 : 2))
    .join(".");
};

export const validateAgeAndCheckIf18OrOlder = (dateStr) => {
  const formatedDate = convertToDate(dateStr);
  const inputDate = parse(formatedDate, "dd.MM.yyyy", new Date());

  if (!regexDate.test(formatedDate)) {
    return "Некорретная дата";
  }

  const eighteenYearsLater = addYears(inputDate, 18);

  return (
    !isBefore(new Date(), eighteenYearsLater) ||
    "Возраст заемщика не соответствует требованиям, установленным Компанией"
  );
};

export const promoCodeMaxLength = 15;
